module.exports = __webpack_public_path__ + "img/text-format.4b5ab578.png";